<template>
  <div>
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      :permission="permissionList"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @row-save="rowSave"
      @row-update="rowUpdate"
      @before-open="beforeOpen"
    >
      <template slot="menuLeft">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="handleRowAdd">新增</el-button>
        <el-button
          type="primary"
          size="small"
          plain
          icon="el-icon-download"
          :loading="exportLoading"
          @click="handleExport"
        >导出</el-button>
        <el-button
          type="default"
          size="small"
          plain
          icon="el-icon-document"
          @click="handleDownloadImportTemplate"
        >导入模板</el-button>
        <el-button type="warning" icon="el-icon-setting" size="small" @click="openFlowConfigDialog">
          审批配置
        </el-button>
        <el-upload
          class="inline-upload"
          action=""
          :show-file-list="false"
          :http-request="handleImport"
          accept=".xls,.xlsx"
        >
          <el-button type="primary" size="small" plain icon="el-icon-upload2" :loading="importLoading">导入</el-button>
        </el-upload>
      </template>
      <template slot="deviceNameForm">
        <el-input
          v-model="form.deviceName"
          placeholder="请选择设备名称"
          readonly
          style="cursor: pointer"
          @click.native="handleOpenDevice"
        >
          <template slot="suffix">
            <i
              v-if="form.deviceId"
              class="el-icon-circle-close"
              style="cursor: pointer"
              @click.stop="removeDevice"
            />
            <i v-else class="el-icon-arrow-right" style="cursor: pointer" />
          </template>
        </el-input>
      </template>

      <template slot="deviceNameSearch" slot-scope="{ search }">
        <el-input
          v-model="search.deviceName"
          placeholder="请选择设备名称"
          readonly
          style="cursor: pointer"
          @click.native="handleOpenSearchDevice(search)"
        >
          <template slot="suffix">
            <i
              v-if="search.deviceId"
              class="el-icon-circle-close"
              style="cursor: pointer"
              @click.stop="removeSearchDevice(search)"
            />
            <i v-else class="el-icon-arrow-right" style="cursor: pointer" />
          </template>
        </el-input>
      </template>

      <template slot="menu" slot-scope="{ row }">
        <el-button type="text" size="small" icon="el-icon-upload2" @click="handleInbound(row)">入库</el-button>
      </template>
    </avue-crud>

    <select-device-dialog ref="selectDeviceDialog" @select="handleDeviceSelect" />

    <inbound-dialog
      :visible.sync="inboundVisible"
      :part-data="currentPart"
      @success="handleInboundSuccess"
    />

    <apply-flow-config-dialog ref="applyFlowConfigDialog" />
  </div>
</template>

<script>
import crudMixins from '@/mixins/crud-mixins'
import { getList, add, update, getDetail, exportExcel, importExcel, downloadImportTemplate } from './api'
import { downloadXls } from '@/util/util'
import InboundDialog from './components/InboundDialog.vue'
import SelectDeviceDialog from './components/SelectDeviceDialog.vue'
import ApplyFlowConfigDialog from './components/ApplyFlowConfigDialog.vue'

export default {
  name: 'system-parts-management',
  mixins: [crudMixins],
  components: {
    InboundDialog,
    SelectDeviceDialog,
    ApplyFlowConfigDialog,
  },
  data() {
    return {
      apiConfig: { getList, add, update, getDetail },
      inboundVisible: false,
      currentPart: {},
      /** 设备选择弹窗：form 新增编辑 / search 查询条件 */
      deviceSelectContext: 'form',
      exportLoading: false,
      importLoading: false,
      option: {
        ...this.$store.state.publicOption,
        menu: true,
        addBtn: false,
        editBtn: true,
        delBtn: false,
        viewBtn: false,
        dialogWidth: '560px',
        dialogClickModal: false,
        column: [
          {
            label: '设备名称',
            prop: 'deviceName',
            formslot: true,
            search: true,
            searchPlaceholder: '请选择设备名称',
            searchSpan: 6,
            searchLabelWidth: 80,
            searchSlot: 'deviceNameSearch',
            minWidth: 140,
            align: 'center',
            overHidden: true,
            span: 24,
            rules: [
              {
                validator: (rule, value, callback) => {
                  const id = this.form.deviceId
                  if (id === '' || id == null || id === undefined) {
                    callback(new Error('请选择设备名称'))
                  } else {
                    callback()
                  }
                },
                trigger: ['change', 'blur'],
              },
            ],
          },
          {
            label: '备件编码',
            prop: 'partCode',
            search: true,
            searchPlaceholder: '备件编码',
            minWidth: 100,
            overHidden: true,
            rules: [{ required: true, message: '请输入编码', trigger: 'blur' }],
            editDisabled: true,
          },
          {
            label: '备件名称',
            prop: 'partName',
            search: true,
            searchPlaceholder: '备件名称',
            overHidden: true,
            minWidth: 140,
            rules: [{ required: true, message: '请输入名称', trigger: 'blur' }],
          },
          {
            label: '备件规格',
            prop: 'specification',
            type: 'input',
            minWidth: 120,
            align: 'center',
            overHidden: true,
            span: 24,
          },
          {
            label: '生产厂家',
            prop: 'manufacturer',
            type: 'input',
            search: true,
            searchPlaceholder: '请输入生产厂家',
            minWidth: 140,
            align: 'center',
            overHidden: true,
            rules: [{ required: true, message: '请输入生产厂家', trigger: 'blur' }],
            span: 24,
          },
          {
            label: '单位',
            prop: 'unit',
            type: 'select',
            dicData: [
              { label: '个', value: '个' },
              { label: '件', value: '件' },
              { label: '套', value: '套' },
              { label: '台', value: '台' },
              { label: 'kg', value: 'kg' },
              { label: 'L', value: 'L' },
              { label: 'm', value: 'm' },
            ],
            minWidth: 80,
            align: 'center',
            span: 24,
          },
          {
            label: '库存数量',
            prop: 'stockCount',
            type: 'number',
            min: 0,
            value: 0,
            minWidth: 100,
            align: 'center',
            span: 24,
          },
          {
            label: '安全库存',
            prop: 'minimumStock',
            type: 'number',
            min: 0,
            value: 5,
            minWidth: 100,
            align: 'center',
            rules: [{ required: true, message: '请输入安全库存', trigger: 'blur' }],
            span: 24,
          },
        ],
      },
    }
  },
  methods: {
    handleRowAdd() {
      if (this.$refs.crud && this.$refs.crud.rowAdd) {
        this.$refs.crud.rowAdd()
      }
    },
    async handleExport() {
      this.exportLoading = true
      try {
        const params = this.formatParams(Object.assign({}, this.defaultParams, this.query))
        const res = await exportExcel(params)
        const name = `备件库存_${Date.now()}.xlsx`
        downloadXls(res.data, name)
        this.$message.success('导出成功')
      } catch (e) {
        console.warn(e)
        this.$message.error((e && e.message) || '导出失败')
      } finally {
        this.exportLoading = false
      }
    },
    async handleDownloadImportTemplate() {
      try {
        const res = await downloadImportTemplate()
        downloadXls(res.data, `备件库存导入模板_${Date.now()}.xlsx`)
        this.$message.success('模板下载成功')
      } catch (e) {
        console.warn(e)
        this.$message.error((e && e.message) || '模板下载失败')
      }
    },
    async handleImport({ file }) {
      if (!file) return
      const name = file.name || ''
      if (!/\.(xls|xlsx)$/i.test(name)) {
        this.$message.error('仅支持 xls、xlsx 文件')
        return
      }
      this.importLoading = true
      try {
        const res = await importExcel(file)
        const result = (res.data && res.data.data) || {}
        this.showImportResult(result)
        this.onLoad(this.page)
      } catch (e) {
        console.warn(e)
        this.$message.error((e && e.message) || '导入失败')
      } finally {
        this.importLoading = false
      }
    },
    showImportResult(result) {
      const successCount = result.successCount || 0
      const failCount = result.failCount || 0
      if (failCount > 0) {
        const errors = (result.errors || []).slice(0, 5).map(item => `第${item.rowNum}行：${item.message}`).join('\n')
        this.$alert(errors || '存在导入失败数据', `导入完成：成功${successCount}条，失败${failCount}条`, {
          type: successCount > 0 ? 'warning' : 'error',
        })
        return
      }
      this.$message.success(`导入成功，共${successCount}条`)
    },
    beforeOpen(done, type) {
      this.openType = type
      if (type === 'add') {
        this.form = {
          partCode: '',
          partName: '',
          specification: '',
          manufacturer: '',
          unit: '个',
          stockCount: 0,
          minimumStock: 5,
          deviceId: '',
          deviceName: '',
        }
        done()
        return
      }
      if (['edit', 'view'].includes(type) && this.apiConfig.getDetail) {
        this.apiConfig.getDetail(this.form.id).then((res) => {
          this.form = res.data.data || res.data
          done()
        })
        return
      }
      done()
    },
    handleOpenDevice() {
      const df = this.$refs.crud && this.$refs.crud.$refs.dialogForm
      if (df && df.boxVisible) {
        this.deviceSelectContext = 'form'
        this.$refs.selectDeviceDialog.open()
      }
    },
    handleOpenSearchDevice(search) {
      this.deviceSelectContext = 'search'
      this._searchDeviceModel = search
      this.$refs.selectDeviceDialog.open()
    },
    handleDeviceSelect(device) {
      if (this.deviceSelectContext === 'search') {
        const sm = this._searchDeviceModel || this.query
        this.$set(sm, 'deviceId', device.id)
        this.$set(sm, 'deviceName', device.deviceName)
        this.deviceSelectContext = 'form'
        this._searchDeviceModel = null
        return
      }
      this.$set(this.form, 'deviceId', device.id)
      this.$set(this.form, 'deviceName', device.deviceName)
      this.$message.success('已关联设备：' + device.deviceName)
      this.$nextTick(() => this.validateDeviceNameField())
    },
    removeDevice() {
      this.$set(this.form, 'deviceId', '')
      this.$set(this.form, 'deviceName', '')
      this.$nextTick(() => this.validateDeviceNameField())
    },
    removeSearchDevice(search) {
      this.$set(search, 'deviceId', undefined)
      this.$set(search, 'deviceName', '')
    },
    validateDeviceNameField() {
      const df = this.$refs.crud && this.$refs.crud.$refs.dialogForm
      const formRef = df && df.$refs && df.$refs.form
      if (formRef && formRef.validateField) {
        formRef.validateField('deviceName')
      }
    },
    handleInbound(row) {
      this.currentPart = { ...row }
      this.inboundVisible = true
    },
    handleInboundSuccess() {
      this.inboundVisible = false
      this.onLoad(this.page, this.query)
    },
    openFlowConfigDialog() {
      this.$refs.applyFlowConfigDialog.open()
    },
  },
}
</script>

<style scoped lang="scss">
.inline-upload {
  display: inline-block;
  margin-left: 8px;
}

::v-deep .el-tag--success {
  background-color: #67c23a;
  border-color: #67c23a;
}

::v-deep .el-tag--primary {
  background-color: #909399;
  border-color: #909399;
}
</style>
